<div class="guest-wrapper-background"></div>

<div class="badge-card" style="padding-inline: 10px;" [ngClass]="{'d-none': !showDownloadApp}">
  <div class="card-body px-5 px-md-5 py-1 h-100">
    <div class="d-flex flex-column h-100" style="justify-content: space-between;">
      <div class="d-flex flex-column align-items-center justify-content-center mt-3">
        <input type="text" class="form-control guest fs-14" style="opacity:0 ;" [formControl]="publicLink" #guestLink>
        <img style="height: 48px;" src="assets/img/workflow-logo.svg" alt="">
      </div>
      <div class="d-flex flex-column justify-content-center">
        <p class="fs-14 text-center">{{ 'MAIN.CONTENT.EASY-ACCESS.OPEN-APP' | translate }}</p>
        <div class="d-flex align-items-center">
          <div class="custom-control custom-checkbox custom-checkbox-green">
            <input type="checkbox" class="form-check-input copy-permission-checkbox" [formControl]="copyPermission">
          </div>
          <div>
            <label class="fs-12" for="">{{ 'MAIN.CONTENT.EASY-ACCESS.COPY-LINK-TEXT' | translate }}</label>
          </div>
        </div>
        <a class="btn btn-primary mt-3 d-flex align-items-center justify-content-center download-button" [href]="downloadAppButtonUrl" (click)="clickStoreLink(guestLink)">
          {{ 'MAIN.CONTENT.EASY-ACCESS.DOWNLOAD-APP' | translate }}
        </a>
      </div>
      <div class="d-flex flex-column align-items-center justify-content-center">
        <div class="fs-16 font-weight-600">{{ 'MAIN.CONTENT.EASY-ACCESS.OR' | translate }}</div>
        <div class="mt-3">
          <a class="continue-website-link mt-3" href="#" (click)="showDownloadApp = false" target="_blank" rel="noopener">{{ 'MAIN.CONTENT.EASY-ACCESS.CONTINUE-WITH-BROWSER' | translate }}</a>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center pb-4">
        <img style="height: 36px;" src="assets/img/logo-horizontal.svg" alt="">
      </div>
    </div>
  </div>
</div>

<!-- Loading/Authentication Screen -->
@if (!workflowLoaded) {
  <div class="guest-wrapper">
    <div class="card align-items-center">
      <div class="mt-5">
        <img style="height: 48px;" src="assets/img/logo.svg" alt="">
      </div>
      <!-- Loading State -->
      @if (loading && !error) {
        <div class="loading-content">
          <div class="spinner-small mt-4"></div>
          <p class="fs-14 font-weight-500 mt-3">{{ 'MAIN.CONTENT.EASY-ACCESS.LOADING-WORKFLOW' | translate }}</p>
        </div>
      }
      <!-- Error State -->
      @if (error) {
        <div class="error-content">
          <div class="error-icon mt-4">⚠</div>
          <p class="fs-16 font-weight-600 mt-3">{{ 'MAIN.CONTENT.EASY-ACCESS.UNABLE-TO-LOAD' | translate }}</p>
          <p class="fs-14 font-weight-500 error-message text-center px-4">{{ error }}</p>
          <button class="v-btn btn btn-primary fs-12 font-weight-600 text-white open-button mt-3 mb-4" (click)="retry()">
            {{ 'MAIN.CONTENT.EASY-ACCESS.RETRY' | translate }}
          </button>
        </div>
      }
      <!-- Success - Show workflow info before loading -->
      @if (!loading && !error && workflowName) {
        <div class="success-content">
          <p class="fs-14 font-weight-600 mt-4">{{ 'MAIN.CONTENT.EASY-ACCESS.EASY-ACCESS-TITLE' | translate:('design' | env) }}</p>
          <p class="fs-14 font-weight-500 mb-1 text-center">{{ 'MAIN.CONTENT.EASY-ACCESS.OPEN-WORKFLOW-NAME' | translate }}<span class="fs-14 font-weight-600 ms-1">{{workflowName}}</span></p>
          @if (companyName) {
            <p><img src="assets/img/company-icon.svg" alt=""><span class="fs-14 font-weight-500 ms-1">{{companyName}}</span></p>
          }
        </div>
      }
    </div>
    <div class="addition-part mt-3 d-flex justify-content-center">
      <div class="language-dropdown" dropdown #dropdown="bs-dropdown">
        <div id="language-toggle" class="language-link d-flex flex-row align-items-center cursor-pointer" dropdownToggle aria-controls="language-menu">
          <span class="name fs-14 font-weight-500 lang ms-2 color-blue-text">{{ currentLang.code | uppercase }}</span>
          <i id="dropdown-icon" class="mi mi-keyboard-arrow-down lang color-blue-text"></i>
        </div>
        <ul id="language-menu" *dropdownMenu class="dropdown-menu py-0" role="menu" aria-expanded="false" aria-labelledby="language-toggle">
          @for (lang of allLangs; track lang) {
            @if (currentLang !== lang) {
              <li class="language-item" role="menuitem">
                <a class="dropdown-item language-link px-2 fs-14 font-weight-500" (click)="onLanguageSelected(lang)">{{ lang.code | uppercase }}</a>
              </li>
            }
          }
        </ul>
      </div>
    </div>
  </div>
}

<!-- Workflow Display -->
@if (workflowLoaded) {
  <div>
    <div class="guest-wrapper-background"></div>
    <div [ngClass]="{'guest-wrapper-mobile': isMobile, 'guest-wrapper': !isMobile}">
      <div class="guest-box">
        <div [ngClass]="{'mobile-guest': isMobile, 'guest-workflow': !isMobile}">
          <div class="workflow-box" cdkDrag  handleResize  [(height)]="boxHeight" [(width)]="boxWidth"
            [style.width.px]="boxWidth" [style.height.px]="boxHeight" [maxWidth]="700" [maxHeight]="700" [minWidth]="400" [minHeight]="300">
          <div cdkDragHandle style="cursor: move;border-bottom: solid 1px #eeeeee;
          padding-bottom: 5px;">
              <div class="d-flex align-items-center">
                <div class="col-2 d-flex h-100 align-items-center justify-content-center">
                  <img src="assets/img/amblem.svg" alt="" style="height: 26px;">
                </div>
                <div class="col-8">
                  @if (wfName) {
                    <label class="cursor-move text-grey">{{wfName}}</label>
                  }
                </div>
                <div class="col-2 d-flex align-items-center justify-content-end">
                  @if (isStepFileAvailable && isStart) {
                    <div class="me-2">
                      <img src="assets/img/step-files-icon.svg" alt="" class="cursor-pointer" (click)="showStepFiles()">
                    </div>
                  }
                  @if (workflow?.showContentPage || (workflow?.expertsToCall?.length > 0)) {
                    <div [ngStyle]="{'pointer-events': isStart ? '' : 'none'}" class="guest-menu">
                      <img src="assets/img/list-content.svg" class="cursor-pointer" alt="" height="13px" (click)="switchWorkflowMenu()">
                    </div>
                  }
                </div>
              </div>
            </div>
            <app-user-workflow
              [ngClass]="{'app-workflow': !isMobile}"
              [workflow]="workflow"
              [initialStepId]="stepId"
              (workflowSubmitted)="workflowSubmitted($event)"
              [remoteUserId]="remoteUserId"
              [token]="idToken"
              [isGuest]="true"
              (langChanged)="langChanged($event)"
              (isWorkflowStart)="isWorkflowStart($event)"
              [(workflowMenuClicked)]="workflowMenuClicked"
              (workflowMenuClickedChange)="workflowMenuClickedChange($event)"
              [(stepFilesClicked)]="stepFilesClicked"
              (isStepFileAvailable)="stepFileAvailability($event)"
              >
            </app-user-workflow>
            <div class="handler"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
